export default {
    device: 'lg',
    log:{
      request:false,
      request_error:false,
    },
    window:{
      width:0,
      height:0
    },
    request:null,
    event:null,
    url_api:null,
    pcmso:null,
    navigation:[],
    env:{},
    sub_domain:null,
}



// WEBPACK FOOTER //
// ./src/store/common/state.js